import { createView } from "@cloudextend/common/routes";

export const login = createView("cefi/login");
export const refreshToken = createView("cefi/refresh-token");
export const connectEcosystem = createView("cefi/connect");
export const listConnections = createView("cefi/connections");
export const noSubscription = createView("cefi/no-subscription");
export const subscriptionExpired = createView("cefi/subscription-expired");
